import { defineEvent } from '../types/event';
export var PRODUCT_CARD_SEE_MORE_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_Product_Card_See_More'
        }
    ]
});
